import React from 'react';
import { Section } from './ui/Section';
export function OldSolutionsFail() {
  return <Section data-id="element-167">
      <h2 className="text-3xl md:text-4xl text-[#f5f0e8] mb-12 text-center md:text-left" data-id="element-168">
        Lo típico no funciona{' '}
        <span className="text-[#8a9bb0] text-2xl block md:inline md:text-3xl" data-id="element-169">
          (y no es culpa tuya)
        </span>
      </h2>

      <div className="space-y-8 mb-12" data-id="element-170">
        <div className="flex gap-4 items-start" data-id="element-171">
          <span className="text-[#c97070] text-xl mt-1" data-id="element-172">•</span>
          <p className="text-lg text-[#f5f0e8]/80 leading-relaxed" data-id="element-173">
            <strong className="text-[#f5f0e8]" data-id="element-174">Infusiones / melatonina:</strong>{' '}
            pueden darte sueño… pero no apagan el carrusel mental.
          </p>
        </div>

        <div className="flex gap-4 items-start" data-id="element-175">
          <span className="text-[#c97070] text-xl mt-1" data-id="element-176">•</span>
          <p className="text-lg text-[#f5f0e8]/80 leading-relaxed" data-id="element-177">
            <strong className="text-[#f5f0e8]" data-id="element-178">Meditación al azar:</strong> te
            sientas y tu mente dice: "perfecto, ahora sí: vamos a hablar."
          </p>
        </div>

        <div className="flex gap-4 items-start" data-id="element-179">
          <span className="text-[#c97070] text-xl mt-1" data-id="element-180">•</span>
          <p className="text-lg text-[#f5f0e8]/80 leading-relaxed" data-id="element-181">
            <strong className="text-[#f5f0e8]" data-id="element-182">Móvil en cama:</strong> anestesia
            20 minutos y luego te deja más despierta.
          </p>
        </div>

        <div className="flex gap-4 items-start" data-id="element-183">
          <span className="text-[#c97070] text-xl mt-1" data-id="element-184">•</span>
          <p className="text-lg text-[#f5f0e8]/80 leading-relaxed" data-id="element-185">
            <strong className="text-[#f5f0e8]" data-id="element-186">Consejos de internet:</strong>{' '}
            "relájate", "piensa en algo bonito"… gracias.
          </p>
        </div>
      </div>

      <div className="border-l-2 border-[#c9a04e] pl-6 py-2" data-id="element-187">
        <p className="text-xl md:text-2xl font-serif text-[#f5f0e8]" data-id="element-188">
          Lo que necesitas no es otro consejo suelto. <br data-id="element-189" />
          <span className="text-[#c9a04e]" data-id="element-190">
            Necesitas una secuencia cerrada que tu cuerpo reconozca.
          </span>
        </p>
      </div>
    </Section>;
}